import { CaretUpFilled, CaretDownFilled } from '@ant-design/icons'
import { Form, List, Space, Tooltip, Typography, Button, Switch } from 'antd'
import { EditHeadersFormListProps } from './types'
import { alphabeticalSort } from 'shared'

const EditHeadersFormList: React.FC<EditHeadersFormListProps> = ({
  headers = [],
}) => {
  const sortedHeaders = headers
    .sort(alphabeticalSort('order'))
    .map(({ id, visible }) => ({ id, visible }))
  return (
    <Form.List name="headers" initialValue={sortedHeaders}>
      {(fields, { move }) => (
        <List
          dataSource={fields}
          size="small"
          renderItem={({ key, name }, i) => (
            <List.Item
              key={key}
              style={{
                justifyContent: 'space-between',
                alignContent: 'center',
              }}
            >
              <Space>
                <Form.Item hidden name={[name, 'id']} />
                <Tooltip title={headers[key].id}>
                  <Typography.Text>{headers[key].label}</Typography.Text>
                </Tooltip>
              </Space>
              <Space>
                <Form.Item
                  noStyle
                  valuePropName="checked"
                  name={[name, 'visible']}
                >
                  <Switch />
                </Form.Item>
                <Button
                  icon={<CaretUpFilled />}
                  disabled={i === 0}
                  shape="circle"
                  onClick={() => move(i, i - 1)}
                />
                <Button
                  icon={<CaretDownFilled />}
                  disabled={i === fields.length - 1}
                  shape="circle"
                  onClick={() => move(i, i + 1)}
                />
              </Space>
            </List.Item>
          )}
        />
      )}
    </Form.List>
  )
}

export default EditHeadersFormList
